<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.MATCH.SH0W_ALL"
    :handler="() => $refs.modal.show()"
  />
  <DialogComponent
    ref="modal"
    type="fullscreen"
    noInnerPadding
    v-slot="{ transitionStatus }"
  >
    <!-- {{ transitionStatus }} -->
    <AllMatches @backClicked="() => $refs.modal.hide()" :loading="transitionStatus=='opening'" />
  </DialogComponent>
</template>
